import {
	isPromoCheckoutId,
	OnboardingStatus,
} from '@/entities/onboarding-status';

export type PaymentAction =
	// Paid, a redeemed promo, or a client that does not pay.
	| { kind: 'skip' }
	// A checkout is in flight: confirm it before offering another one.
	| {
			kind: 'poll';
			checkoutId: string;
			checkoutUrl: string | null;
			productId: string | null;
	  }
	// productId is null when no plan is known: the user has to pick one.
	| { kind: 'checkout'; productId: string | null };

export function decidePaymentAction(
	status: OnboardingStatus,
	selectedProductId: string | undefined,
): PaymentAction {
	if (!status.payment_required || status.payment_status === 'PAID') {
		return { kind: 'skip' };
	}

	// The product picked in this session wins; a resumed wizard has none.
	const productId = selectedProductId || status.product_id || null;

	if (
		status.payment_status === 'PENDING' &&
		status.checkout_id &&
		!isPromoCheckoutId(status.checkout_id)
	) {
		return {
			kind: 'poll',
			checkoutId: status.checkout_id,
			checkoutUrl: status.checkout_url,
			productId,
		};
	}

	return { kind: 'checkout', productId };
}
